import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Truck } from '@phosphor-icons/react';

const DriverLoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setBusy(true);
    const result = await login(email, password);
    setBusy(false);
    if (!result.success) {
      toast.error(result.error || 'Identifiants incorrects');
      return;
    }
    if (result.user.role !== 'driver') {
      toast.error("Ce compte n'est pas un compte livreur.");
      return;
    }
    toast.success(`Bienvenue ${result.user.name}`);
    navigate('/livreur');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-[#0052FF] flex items-center justify-center mb-2">
            <Truck size={28} className="text-white" />
          </div>
          <CardTitle>Espace Livreur</CardTitle>
          <CardDescription>MRG Optique & Audition — Tournée du jour</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input
                type="email" required autoFocus
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="livreur@mrg-istres.fr"
                data-testid="driver-email"
              />
            </div>
            <div>
              <Label>Mot de passe</Label>
              <Input
                type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="driver-password"
              />
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-[#0052FF] hover:bg-[#0040CC]" data-testid="driver-login-submit">
              {busy ? 'Connexion…' : 'Se connecter'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default DriverLoginPage;
